import React, { useEffect, useState } from "react";
import styles from "../footer/FooterNavbar.module.css";
import { ContactData } from "../../controller/ContactData";
import { Company } from "../../controller/Navdata";
import { Product } from "../../controller/Navdata";
import { navItems } from "../../controller/Navdata";

import {
  Colorlogo,
  mslogo,
  quality,
  ISO,
  email,
  phone,
  place,
  White_Linkedin,
  White_Twitter,
  White_Facebook,
  White_Instagram,
} from "../../controller/Images";
import MobileFooter from "./MobileFooter";
import { useNavigate } from "react-router-dom";

function Footer({ noPadding }) {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 992);
  const navigate = useNavigate();

  const insightsItem = navItems.find((item) => item.name === "Insights");

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isDesktop ? (
    <>
      <div
        className={`container-fluid  ${styles.footer_container} ${styles.custom_container}  d-lg-block`}
      >
        <div style={{ maxWidth: "1480px", margin: "0 auto", width: "100%" }}>
          <div className="d-flex justify-content-center align-items-center text-center pt-2 ">
            <div
              className={`col-md-4 d-flex flex-column align-items-center py-4`}
            >
              <img
                src={Colorlogo}
                alt="Default Company Logo"
                height="130"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/")}
              />
            </div>

            <div
              className={`col-md-5 d-flex pt-3 ${styles.footerlinks} ${styles.custom_border}`}
            >
              <div className={`col-6 text-start px-2 ${styles.footerlist}`}>
                <h5 className="mb-3">OUR COMPANY</h5>
                <ul className="list-unstyled">
                  <ul className="list-unstyled">
                    {Company.map((item, index) => {
                      const isGroupLabel =
                        item.name === "Insights" &&
                        insightsItem?.children?.length;

                      return (
                        <li key={index}>
                          {isGroupLabel ? (
                            <span className={styles.groupLabel}>
                              {item.name}
                            </span>
                          ) : (
                            <a
                              className={styles.footerlinks}
                              href={item.path || "#"}
                            >
                              {item.name}
                            </a>
                          )}

                          {item.name === "Insights" &&
                            insightsItem?.children && (
                              <ul className={styles.erpSubmenu}>
                                {insightsItem.children.map(
                                  (child, childIndex) => (
                                    <li key={childIndex}>
                                      <a href={child.path || "#"}>
                                        {child.name}
                                      </a>
                                    </li>
                                  ),
                                )}
                              </ul>
                            )}
                        </li>
                      );
                    })}
                  </ul>
                </ul>
              </div>

              <div className={`col-6 text-start px-2 ${styles.footerlist}`}>
                <h5 className="mb-3">SERVICES AND PRODUCTS</h5>
                <ul className="list-unstyled">
                  {Product.map((item, index) => {
                    return (
                      <li key={index}>
                        <a href={item.path || "#"}>{item.name}</a>

                        {item.name === "Insights" && insightsItem?.children && (
                          <ul className={styles.erpSubmenu}>
                            {insightsItem.children.map((child, childIndex) => (
                              <li key={childIndex}>
                                <a href={child.path || "#"}>{child.name}</a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="col-md-3 d-flex flex-column align-items-center pt-2">
              <div>
                <img src={mslogo} alt="MS Logo" height="50" />
              </div>
              <div className="d-flex gap-3 mt-5">
                <img src={quality} alt="Quality Logo" height="100" />
                <img src={ISO} alt="ISO Logo" height="100" />
              </div>
            </div>
          </div>
          <div
            className={`container-fluid mt-4 py-4 ${styles.address_title} ${styles.footerSection}`}
          >
            <div className="row">
              <div className="col-6">
                <div
                  className={`d-flex align-items-center ${styles.footerItem}`}
                >
                  <img src={email} alt="email icon" height="25" />
                  <p className={`mb-0 ms-2 ${styles.footerText}`}>
                    {ContactData[0].text}
                  </p>
                </div>

                <div
                  className={`d-flex align-items-center ${styles.footerItem}`}
                >
                  <img src={phone} alt="phone icon" height="25" />
                  <p className={`mb-0 ms-2 ${styles.footerText}`}>
                    {ContactData[1].text}
                  </p>
                </div>

                <div
                  className={`d-flex align-items-start ${styles.footerItem}`}
                >
                  <img src={place} alt="address icon" height="25" />
                  <p className={`mb-0 ms-2 ${styles.footerText}`}>
                    {ContactData[2].text}
                  </p>
                </div>
              </div>

              <div className={`col-6 text-center ${styles.sociallinks}`}>
                <h5 style={{ color: "#fff" }}>FOLLOW</h5>

                <div className="d-flex flex-column align-items-center">
                  <ul
                    className="list-unstyled m-0"
                    style={{ width: "fit-content" }}
                  >
                    <li className="text-start mb-2">
                      <a
                        href="https://www.linkedin.com/company/bharatclouds/about/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        <img
                          src={White_Linkedin}
                          alt="LinkedIn Icon"
                          height="20"
                          className="me-2"
                        />
                        LinkedIn
                      </a>
                    </li>
                    <li className="text-start mb-2">
                      <a
                        href="https://x.com/BharatClouds"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        <img
                          src={White_Twitter}
                          alt="Twitter Icon"
                          height="20"
                          className="me-2"
                        />
                        X
                      </a>
                    </li>
                    <li className="text-start mb-2">
                      <a
                        href="https://www.facebook.com/bharatcloudspvtltd/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        <img
                          src={White_Facebook}
                          alt="Facebook Icon"
                          height="20"
                          className="me-2"
                        />
                        Facebook
                      </a>
                    </li>
                    <li className="text-start mb-2">
                      <a
                        href="https://www.instagram.com/bharatclouds/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        <img
                          src={White_Instagram}
                          alt="Instagram Icon"
                          height="20"
                          className="me-2"
                        />
                        Instagram
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${styles.footer_bottom} d-flex align-items-center justify-content-between`}
          >
            <div className="col-6">
              <p className="m-0">
                Copyright © {new Date().getFullYear()} Bharat Clouds Private
                Limited. All rights reserved.
              </p>
            </div>

            <div className="col-6 text-center">
              <a href="/terms-of-use" className="me-2">
                Terms of Use
              </a>
              /
              <a href="/privacy-policy" className="ms-2">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <MobileFooter />
  );
}

export default Footer;
